const Footer = () => {
  return (
    <div className="w-full relative flex flex-row items-center justify-end py-16 box-border text-left text-sm text-neutrals-neutral-300 font-open-sans-ff-meta">
      <div className="relative">Copyright © 6EL∆ 2026</div>
    </div>
  );
};

export default Footer;
